import { useState, useEffect } from "react";
import { getCost } from "../lib/api";

export function useCost() {
  const [daily, setDaily] = useState(0);
  const [monthly, setMonthly] = useState(0);
  const [loaded, setLoaded] = useState(false);

  const refresh = async () => {
    try {
      const data = await getCost();
      setDaily(data.daily_total_usd ?? 0);
      setMonthly(data.monthly_total_usd ?? 0);
      setLoaded(true);
    } catch (e) {
      console.warn("[useCost] failed to fetch:", e);
      // Don't reset to 0 if we already have data — only show 0 on genuine $0 spend
      if (!loaded) {
        setDaily(0);
        setMonthly(0);
      }
    }
  };

  useEffect(() => { refresh(); }, []);

  return { daily, monthly, loaded, refresh };
}
